import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/laboratorio/getTrabajosByIdLaboratorio.php';

export default function getTrabajosByIdLaboratorio({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}